module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_c('router-link', {
    staticClass: "hidden-xs",
    attrs: {
      "to": {
        name: 'selection'
      }
    }
  }, [_vm._v("\n\t\t\tPokémon Battle\n\t\t")]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "form-inline"
  }, [(_vm.apis.length) ? _c('div', {
    staticClass: "form-group hidden-xs"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedApi),
      expression: "selectedApi"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Backend Api"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedApi = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeApi]
    }
  }, _vm._l((_vm.apis), function(api) {
    return _c('option', {
      domProps: {
        "value": api
      }
    }, [_vm._v(_vm._s(api.name))])
  }))]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "btn btn-default fa fa-info-circle help",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.help
    }
  })]), _vm._v(" "), _c('help', {
    ref: "help"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b51fbef","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/index.vue
// module id = 121
// module chunks = 1